<template>
  <div class="row z-depth-1">
    <div >
        <table class="striped centered responsive-table">
            <thead>
                <tr>
                  <th>{{$t('pressRelease.headline')}}</th>
                    <th>{{$t('pressRelease.date')}}</th>
                    <th>{{$t('global.keywords')}}</th>
                     <th>{{$t('pressRelease.contentOfPage')}}</th>
                      <th>{{$t('global.downloadFile')}}</th> 
                </tr>
            </thead>
            <tbody>
                <tr v-for="data in pressRelease" :key="data.id">
                   <td >{{data.headline}}</td> 
                       <td>{{data.date | formatDate}}</td>
                       <td >{{data.keywords}}</td>
                       <td >{{data.content}}</td>
                       <td>
                            <div v-for="attachment in data.attachments" :key="attachment.url">
                                <a target="_blank" :href="attachment.url">{{attachment.fileName}}</a>
                            </div>
                        </td>
                </tr>
                
            </tbody>
        </table>
    </div>
</div>
</template>

<script>
import axiosCommon from '@/axios-common/axios-common';
export default {
name:'PressRelease',
dependencies:['localeService'],
data () {
    return{
        pressRelease:{}
    }
},
 mounted() {
        this.getPressReleaseData()
    },
      methods: {
            getPressReleaseData(){
                let vm = this;
               axiosCommon.get(`/o/pressReleases?language=${vm.localeService.getCurrentLocale()}&`)
        .then(response => {
         this.pressRelease = response.data
        })
        .catch(e => {
          console.log('error ')
          console.log(e)
        })
            }
      }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/media/pressRelease.vue